export class Progress {
    icon: string;
    header: string;
    desc: string;
    progressMsg: string;
    scale: number;
    cta: string;
    constructor(icon: string = '', header: string, desc: string = '', progressMsg: string = '', scale: number = 0, cta: string = '') {
        this.icon = icon;
        this.header = header;
        this.desc = desc;
        this.progressMsg = progressMsg;
        this.scale = scale;
        this.cta = cta;
    }
}
